<template>
    <section v-if="props.modelValue" class="modal">
        <article class="modal__content">
            <h4 class="modal__title">Agregar Nueva Aplicación</h4>
            <form @submit.prevent="saveApplication" class="modal__form">
                <div class="modal__group">
                    <label for="appName">Nombre de la Aplicación</label>
                    <input id="appName" v-model="appName" type="text" class="modal__input" required />
                </div>
                
                <div class="modal__group">
                    <label for="moduleName">Módulo</label>
                    <input id="moduleName" v-model="moduleName" type="text" class="modal__input" />
                    <button type="button" @click="addModule" class="modal__button">Agregar</button>
                </div>
                <ul class="modal__list">
                    <li v-for="(module, index) in modules" :key="index">{{ module }}</li>
                </ul>
                
                <div class="modal__group">
                    <label for="permissions">Permisos</label>
                    <select id="permissions" v-model="selectedPermissions" class="modal__select">
                        <option v-for="perm in availablePermissions" :key="perm" :value="perm">{{ perm }}</option>
                    </select>
                    <button type="button" @click="addPermissions" class="modal__button">Agregar</button>
                </div>
                <ul class="modal__list">
                    <li v-for="(perm, index) in permissions" :key="index">{{ perm }}</li>
                </ul>
                
                <button type="submit" class="modal__submit">Guardar</button>
            </form>
            <button class="modal__close" @click="closeModal">&times;</button>
        </article>
    </section>
</template>

<script setup>
import { defineProps, defineEmits, ref } from 'vue';

const props = defineProps({
    modelValue: Boolean
});
const emit = defineEmits(['update:modelValue']);

const appName = ref('');
const moduleName = ref('');
const modules = ref([]);
const selectedPermissions = ref([]);
const permissions = ref([]);
const availablePermissions = ref(['Leer', 'Escribir', 'Eliminar', 'Actualizar']);

const closeModal = () => {
    emit('update:modelValue', false);
};

const addModule = () => {
    if (moduleName.value.trim()) {
        modules.value.push(moduleName.value.trim());
        moduleName.value = '';
    }
};

const addPermissions = () => {
    if (!selectedPermissions.value || permissions.value.includes(selectedPermissions.value)) {
        return;
    }
    if (selectedPermissions.value) {
        permissions.value.push(selectedPermissions.value);
    }
};


const saveApplication = () => {
    console.log({ appName: appName.value, modules: modules.value, permissions: permissions.value });
    closeModal();
};
</script>

<style scoped src="../styles/modalAddApp.css"></style>
